export default __webpack_public_path__ + "b7a93ace461df94f1636d80e97201172.png";